import { css } from "@emotion/react";

export const playlistHeader = css`
  margin-bottom: 30px;
  color: #e0e0e0;

  .back-button {
    display: inline-flex;
    align-items: center;
    color: #1890ff;
    cursor: pointer;
    margin-bottom: 20px;
    font-size: 16px;

    &:hover {
      color: #40a9ff;
    }

    .anticon {
      margin-right: 8px;
    }
  }

  h1 {
    margin: 0 0 10px;
    font-size: 24px;
  }

  .meta {
    color: #808080;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .description-container {
    position: relative;
    
    .description {
      color: #b0b0b0;
      font-size: 16px;
      white-space: pre-wrap;
      margin: 0;
      transition: max-height 0.3s ease;

      &.collapsed {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }

    .toggle-description {
      color: #b0b0b0;
      cursor: pointer;
      margin-top: 8px;
      font-size: 14px;
      display: inline-block;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const videoList = css`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
`;

export const videoCard = css`
  background: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    border-color: #4a4a4a;
    background: #333333;
  }

  .thumbnail {
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio */
    background: #1a1a1a;
    border-bottom: 1px solid #3a3a3a;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: opacity 0.2s ease;

      &.loading {
        opacity: 0;
      }

      &.loaded {
        opacity: 1;
      }
    }
  }

  .info {
    padding: 12px;

    h3 {
      margin: 0 0 8px;
      font-size: 16px;
      color: #e0e0e0;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      line-height: 1.4;
    }

    .description {
      color: #b0b0b0;
      font-size: 14px;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      margin: 0;
    }
  }
`;
